import { install } from 'resize-observer';

export default function initPolyfills() {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!window.ResizeObserver) install();
}
